import { createElement, type ComponentType } from 'react';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  FourInTheBoxSection,
  ParentGroupPicker,
  PersonnelPicker,
  ResourceLinkEditor,
} from '@internal/backstage-plugin-team-management-frontend';

// PAT-1025: the team-management plugin's scaffolder fields, registered here
// because that plugin is still on the legacy frontend system.
// TODO(PAT-1034): move these into the team-management plugin when it is
// migrated, and drop its legacy `*Extension` exports.
//
// These components take `value`/`onChange` props, while the alpha form-field
// API passes `formData`/`onChange` (`FieldExtensionComponentProps`), so each
// one is wrapped in an adapter that maps `formData` to `value`.
function withValueProp(Component: ComponentType<any>): any {
  return function ValueAdapter(props: any) {
    const { formData, ...rest } = props;
    return createElement(Component, { ...rest, value: formData });
  };
}

// Empty initial data for the object/array fields, which dereference `value`
// on first render before the form has produced anything.
function withDefault(Component: ComponentType<any>, fallback: unknown): any {
  const Adapted = withValueProp(Component);
  return function DefaultAdapter(props: any) {
    return createElement(Adapted, {
      ...props,
      formData: props.formData ?? fallback,
    });
  };
}

export const parentGroupPickerFormField = FormFieldBlueprint.make({
  name: 'parent-group-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'ParentGroupPicker',
        component: withValueProp(ParentGroupPicker),
      }),
  },
});

export const personnelPickerFormField = FormFieldBlueprint.make({
  name: 'personnel-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'PersonnelPicker',
        component: withValueProp(PersonnelPicker),
      }),
  },
});

export const fourInTheBoxSectionFormField = FormFieldBlueprint.make({
  name: 'four-in-the-box-section',
  params: {
    field: async () =>
      createFormField({
        name: 'FourInTheBoxSection',
        component: withDefault(FourInTheBoxSection, {}),
      }),
  },
});

export const resourceLinkEditorFormField = FormFieldBlueprint.make({
  name: 'resource-link-editor',
  params: {
    field: async () =>
      createFormField({
        name: 'ResourceLinkEditor',
        component: withDefault(ResourceLinkEditor, []),
      }),
  },
});

export const teamManagementFormFields = [
  parentGroupPickerFormField,
  personnelPickerFormField,
  fourInTheBoxSectionFormField,
  resourceLinkEditorFormField,
];
